import { API_PREFIX } from '@/config/api'
import type {
    CustomerCreateModel,
    CustomerModel,
    CustomerUpdateModel
} from '@/types/models/CustomerModel'
import { api } from '@rfc/rfc-components-library/helpers'
import type { PaginationDataType, PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'
import type { AxiosResponse } from 'axios'

const CUSTOMERS_API_PREFIX = `${API_PREFIX}/customers`

export type CustomerFilters = {
    organization_id?: number
}

const customersApi = {
    getCustomers: (
        params?: Partial<PaginationType & CustomerFilters>
    ): Promise<PaginationDataType<CustomerModel[]>> =>
        api.get(`${CUSTOMERS_API_PREFIX}${buildQueryUrl(params)}`).then(res => res.data),

    getCustomer: (id: number): Promise<AxiosResponse<CustomerModel>> =>
        api.get(`${CUSTOMERS_API_PREFIX}/${id}`).then(res => res.data),

    createCustomer: (data: CustomerCreateModel): Promise<AxiosResponse<CustomerModel>> =>
        api.post(CUSTOMERS_API_PREFIX, data),

    updateCustomer: (
        id: number,
        data: CustomerUpdateModel
    ): Promise<AxiosResponse<CustomerModel>> => api.patch(`${CUSTOMERS_API_PREFIX}/${id}`, data),

    deleteCustomer: (id: number): Promise<AxiosResponse<{ message: string }>> =>
        api.delete(`${CUSTOMERS_API_PREFIX}/${id}`)
}

export default customersApi
